import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { accountShape, bibShape, holdItemShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import { SecondarySolidButton } from '@bibliocommons/base-buttons';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import CancelHoldForm from './CancelHoldForm';

export default class CancelHoldButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
    this.modalKey = `cancel-hold-modal-${this.props.bib.get('id')}`;
  }

  handleOpen() {
    this.props.modalActions.openModal(this.modalKey, { accountRequired: true });
  }

  handleClose() {
    this.props.modalActions.closeModal(this.modalKey);
  }

  renderModal() {
    const {
      bib,
      currentAccount,
      holdItem,
      holdsTransactions,
      shelfTransactions,
      holdActions,
      shelfActions
    } = this.props;

    return (
      <ModalContainer modalKey={this.modalKey} handleClose={this.handleClose}>
        <CancelHoldForm
          bib={bib}
          currentAccount={currentAccount}
          holdItem={holdItem}
          holdsTransactions={holdsTransactions}
          shelfTransactions={shelfTransactions}
          handleClose={this.handleClose}
          holdActions={holdActions}
          shelfActions={shelfActions}
        />
      </ModalContainer>
    );
  }

  render() {
    return (
      <div className="cp-cancel-hold-button">
        <SecondarySolidButton block handleClick={this.handleOpen} disabled={this.props.disabled}>
          <FormattedMessage id="cancel_hold" />
        </SecondarySolidButton>
        {this.renderModal()}
      </div>
    );
  }
}

CancelHoldButton.propTypes = {
  bib: bibShape.isRequired,
  disabled: PropTypes.bool,
  holdItem: holdItemShape.isRequired,
  currentAccount: accountShape.isRequired,
  holdsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};
